import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { twMerge } from 'tailwind-merge'
import { listItemVariants } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuCheckboxItemProps extends PartProps<BaseContextMenu.CheckboxItem.Props> {
  className?: string
}

function ContextMenuCheckboxItem({ className, children, ...props }: ContextMenuCheckboxItemProps) {
  return (
    <BaseContextMenu.CheckboxItem data-slot="list-item" className={twMerge(listItemVariants(), className)} {...props}>
      {children}
    </BaseContextMenu.CheckboxItem>
  )
}

export { ContextMenuCheckboxItem }
